export const CREATED_AT_SLUG = 'created_at'
export const BASE_CARD_SLUG = 'base-card'